import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EntityEditorModule } from '../entity-editor/entity-editor.module';
import { SharedModule } from '../shared/shared.module';
import { LoginViewComponent } from './views/login-view/login-view.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store';
import { EffectsModule } from '@ngrx/effects';
import { LoginEntityEffects } from './store/login-entity/login-entity.effects';
import { LoginEffects } from './store/session/session.effects';
import { LogoutViewComponent } from './views/logout-view/logout-view.component';
import { RecoverPasswordViewComponent } from './views/recover-password/recover-password-view.component';
import { ResetPasswordViewComponent } from './views/reset-password/reset-password-view.component';
import { RouterLink } from '@angular/router';
import { PasswordEffects } from './store/password/password.effects';

@NgModule({
  declarations: [LoginViewComponent, LoginFormComponent, LogoutViewComponent, RecoverPasswordViewComponent, ResetPasswordViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    EntityEditorModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([LoginEntityEffects, LoginEffects, PasswordEffects]),
    RouterLink
  ],

  exports: [LoginViewComponent, LogoutViewComponent]
})
export class AuthModule {}
